var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',_vm._l((_vm.groups),function(group){return _c('li',[(group.complete)?_c('sprite',{staticClass:"icon-complete",attrs:{"name":"iconCheck"}}):_c('sprite',{staticClass:"icon-incomplete",attrs:{"name":"iconCheckOutline"}}),_vm._v(" "),_c('h3',[_vm._v(_vm._s(group.title))])],1)}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07a8cb76","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_global/assignment-completion-summary.vue
// module id = null
// module chunks = 